"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_POPOVER_CONTENT_WITDH = void 0;
exports.DEFAULT_POPOVER_CONTENT_WITDH = "240px";
//# sourceMappingURL=Popover.constants.js.map